import { Card, CardFooter, CardHeader } from "@/components/ui/v2/card";
import { Skeleton } from "@/components/ui/v2/skeleton";

function ModuleCardSkeleton() {
  return (
    <Card className="p-4 gap-0 h-full w-full flex flex-col justify-between">
      <CardHeader className="flex flex-col gap-3 space-y-0 p-0 mb-4">
        <Skeleton className="h-6 w-3/4" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6" />
      </CardHeader>

      <CardFooter className="flex items-center justify-between pt-3 p-0 w-full gap-3 border-t border-border">
        <div className="flex items-center gap-3 w-2/3 justify-start">
          <Skeleton className="h-6 w-16" />
        </div>
        <div className="w-1/3 flex-1 justify-end">
          <Skeleton className="h-8 w-full" />
        </div>
      </CardFooter>
    </Card>
  );
}

function ModuleCardSkeletonGrid() {
  return (
    <div className="grid w-full grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 items-stretch">
      {Array.from({ length: 3 }).map((_, index) => (
        <ModuleCardSkeleton key={`skeleton-${index}`} />
      ))}
    </div>
  );
}

export { ModuleCardSkeleton, ModuleCardSkeletonGrid };
export default ModuleCardSkeletonGrid;
